<template>
  <b-container>
    <div class="row mb-3">
      <div class="col-lg-6 col-sm-11 pl-0 h4 text-right">{{ title }}</div>
      <div class="col-lg-6 col-sm-1 text-left">

        <router-link :to="{ name: 'Deliveries' }" class="ml-2">
          <b-button pill variant="purple"> بازگشت به صفحه نرخ پست ها</b-button>
        </router-link>

      </div>
    </div>
    <form @submit.prevent="onSubmit">


      <b-col lg="12" class="mt-5 mb-5">


        <b-form-row>
          <form-group class="col-lg-3  mb-3 text-right " :validations="$v.form.deliverables_type">
            <div slot-scope="{ errors, invalid }">
              <label>نوع</label>

              <select :disabled="pageMode" v-model="form.deliverables_type" class="custom-select">
                <option value="">یکی از موارد را انتخاب کنید</option>
                <option v-for="item in DeliveryTypes " :value="item.value">{{ item.text }}</option>
              </select>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group class="col-lg-9 alert alert-info text-center mb-3 text-right " v-if="form.deliverables_type != ''"
                      :validations="$v.form.deliverables_id">
            <div slot-scope="{ errors, invalid }">


              <form @submit.prevent="searchItem()">
                <label>جست وجو</label>
                <input :disabled="pageMode" v-model="searchWord" type="text" class="form-control">
                {{ form.searchWord }}
              </form>

              <p class="btn btn-primary my-2 rounded-pill" v-if="selectedItem!=''">
                {{ selectedItem.name }}
              </p>

             <div v-if="!pageMode">


               <hr>

               <p class="my-3 cursor-pointer" v-for="item in searchItemResult()" @click="setDeliverables_id(item)">
                 {{ item.name }}
               </p>

             </div>

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>


        </b-form-row>

        <b-form-row>

          <form-group class="col-lg-4 col-md-6 mb-3 text-right " :validations="$v.form.price">
            <div slot-scope="{ errors, invalid }">
              <label>قیمت</label>

              <input v-model="form.price" type="text" class="form-control">

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group class="col-lg-4 col-md-6 mb-3 text-right " :validations="$v.form.percent_per_item">
            <div slot-scope="{ errors, invalid }">
              <label>درصد</label>

              <input v-model="form.percent_per_item" type="text" class="form-control">

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

          <form-group class="col-lg-4 col-md-6 mb-3 text-right " :validations="$v.form.priority">
            <div slot-scope="{ errors, invalid }">
              <label>اولویت</label>

              <input v-model="form.priority" type="text" class="form-control">

              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

        </b-form-row>

      </b-col>


      <button type="submit" class="btn btn-primary rounded-pill mt-2 w-100">ثبت</button>


    </form>


  </b-container>
</template>

<script>
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager";
import {required, numeric} from "vuelidate/lib/validators";
import {DeliveryTypes} from '@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Delivery'
import {mapGetters} from "vuex";

export default {
  name: "CreateLayout",
  props: ['title', 'submitFunction'],
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      form: {
        price: '',
        priority: '',
        percent_per_item: '',
        deliverables_type: '',
        deliverables_id: '',
      },
      DeliveryTypes,
      searchWord: '',
      selectedItem: []
    }
  },
  computed: {
    ...mapGetters({
      brands: "Brand/getBrands",
      categories: 'Category/getCategories',
    }),
    pageMode() {
      return this.$route.params.id !== undefined;
    }
  },
  validations: {
    form: {
      price: {required, numeric},
      priority: {required, numeric},
      percent_per_item: {numeric},
      deliverables_type: {required},
      deliverables_id: {required},
    }
  },
  methods: {
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        const form = this.form
        this.submitFunction(form)
      }
    },
    async searchItem() {

      const type = this.form.deliverables_type;
      const words = this.searchWord;

      const form = {words: words}
      if (type === 'brand') {
        await this.$store.dispatch('Brand/searchBrand', {form, page: 1})
      }
      if (type === 'category') {
        await this.$store.dispatch('Category/search', {form})
      }
    },
    searchItemResult() {
      const type = this.form.deliverables_type;
      if (type === 'brand') {
        return this.brands.slice(0, 5)
      }
      if (type === 'category') {
        return this.categories.slice(0, 5)
      }
      return []
    },
    setDeliverables_id(item) {
      this.form.deliverables_id = item.id;
      this.selectedItem = item
    }
  },
  mounted() {
    if (this.pageMode) {
      this.form.id = this.$route.params.id;
      const form = this.form
      this.$store.dispatch('Delivery/setDelivery', form).then(res => {
        const delivery = res.data.data;

        form.price = delivery.price
        form.priority = delivery.priority
        form.percent_per_item = delivery.percent_per_item
        form.deliverables_type = delivery.deliverables_type
        form.deliverables_id = delivery.deliverables_id

        this.selectedItem = delivery.deliverables

      }).catch(err => {
        this.$router.push({name: 'Deliveries'})
      })
    }
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}


</style>